import type { JSX } from 'react';

import { useGetProjectQuery } from 'features/projects';
import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { useGetStandardAlertsQuery } from '../services/alerts.api';
import { isSubProjectDetail } from '../ui/project-detail.types';
import ProjectAlertsConfigEditorContent from './ProjectAlertsConfigEditorContent';

interface ProjectAlertsConfigEditorProps {
  projectId: number;
}

const ProjectAlertsConfigEditor = ({ projectId }: ProjectAlertsConfigEditorProps): JSX.Element => {
  const { data: project, isLoading, isError, refetch } = useGetProjectQuery(projectId);
  const { data: standardAlerts, isLoading: isLoadingStandardAlerts } = useGetStandardAlertsQuery(undefined, {
    skip: !project || isSubProjectDetail(project),
  });

  if (isLoading || isLoadingStandardAlerts) {
    return (
      <div className="flex items-center gap-2 py-8 text-sm text-text-muted font-body">
        <Loader2 className="size-4 animate-spin shrink-0" aria-hidden />
        Cargando configuración de alertas…
      </div>
    );
  }

  if (isError || !project) {
    return (
      <div className="rounded-lg border border-border-subtle bg-bg-surface-alt p-4 text-sm font-body">
        <p className="m-0 mb-3 text-text-muted">No se pudo cargar el proyecto.</p>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => {
            refetch().catch(() => {});
          }}
        >
          Reintentar
        </Button>
      </div>
    );
  }

  return (
    <ProjectAlertsConfigEditorContent project={project} projectId={projectId} standardAlerts={standardAlerts ?? []} />
  );
};

export default ProjectAlertsConfigEditor;
